import {InjectionToken} from '@angular/core';

import {BehaviorSubject} from 'rxjs';

import {Organization} from 'frontend/utils/organization';

import {ColorTheme} from './config_types';
import {UserScopeService} from './user_scope_service';

/**
 * Defines the shared interface for all application configuration services.
 * Each application's specific `ConfigService` should implement this interface
 * to provide consistent access to common configuration data.
 * TODO: Add other methods required by shared components, and ensure they use
 *  CONFIG_SERVICE_TOKEN instead of direct service injection.
 */
export interface BaseConfigService {
  colorThemeChanged: BehaviorSubject<ColorTheme>;
  setColorTheme(theme: ColorTheme): void;
  getOrganization(): Organization | null;
  getDefaultTimezone(): string;
  userScope: UserScopeService;
}

/**
 * InjectionToken used to inject the application's configuration service.
 * Shared components and services should depend on this token to obtain an
 * instance of the provided `BaseConfigService` implementation instead of
 * direct service injection.
 */
export const CONFIG_SERVICE_TOKEN = new InjectionToken<BaseConfigService>('CONFIG_SERVICE_TOKEN');
